import { render, staticRenderFns } from "./ProgressLabel.vue?vue&type=template&id=d85d1aa8&"
import script from "./ProgressLabel.vue?vue&type=script&lang=js&"
export * from "./ProgressLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports